//src/pages/DictaSetsList.jsx
import React, { useCallback, useEffect, useState, useRef } from 'react';
import { useSelector } from 'react-redux';
import { Link, useLocation } from 'react-router-dom';
import useFetch from '../../hooks/useFetch';
import 'react-datepicker/dist/react-datepicker.css';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faPlus } from '@fortawesome/free-solid-svg-icons';
import Loader from '../../components/utils/Loader';
import Tooltip from '../../components/utils/Tooltip';
import MainLayout from '../../layouts/MainLayout';

const DictaSetList = () => {
  const authState = useSelector(state => state.authReducer);
  const { isLoggedIn } = authState;
  const location = useLocation();
  const [bookMasters, setBookMasters] = useState([]);
  const [fetchData, { loading }] = useFetch();
  const [selectedBookMasterId, setSelectedBookMasterId] = useState(null);

  useEffect(() => {
    document.title = authState.isLoggedIn ? `${authState.user.name}'s dashboard` : "Think5Whys";
  }, [authState]);

  const fetchBookMasters = useCallback(() => {
      const config = {
        url: "/books/mybookmasterslist",
        method: "post",
        headers: { Authorization: authState.token },
        data: { userId: authState.user._id}
      };
    // console.log("My BookMaster Search Payload: ", config);
  
    fetchData(config, { showSuccessToast: false }).then(data => {
      // console.log("Fetched data: ", data); 
      setBookMasters(data.bookmasters);
    });
  }, [authState.token, fetchData, authState.user._id]);
  
  useEffect(() => {
    if (!authState.isLoggedIn) return;
    fetchBookMasters();
  }, [authState.isLoggedIn, fetchBookMasters]);

  const handleView = (bookMasterId) => {
    setSelectedBookMasterId(prevId => (prevId === bookMasterId ? null : bookMasterId));
  };

   const handleBookMasterClick = (bookMasterId) => {
    setSelectedBookMasterId(bookMasterId);
  };

  const sortedBookMasters = [...bookMasters].sort((a, b) => new Date(b.bookMasterDate) - new Date(a.bookMasterDate));

  const formatDateTime = (date) => {
    const options = {
        year: 'numeric', month: '2-digit', day: '2-digit',
        hour: '2-digit', minute: '2-digit', second: '2-digit',
        hour12: false
    };
    const jsDate = new Date(date);
    const day = jsDate.getDate().toString().padStart(2, '0');
    const month = (jsDate.getMonth() + 1).toString().padStart(2, '0');
    const year = jsDate.getFullYear();
    const hours = jsDate.getHours().toString().padStart(2, '0');
    const minutes = jsDate.getMinutes().toString().padStart(2, '0');
    const seconds = jsDate.getSeconds().toString().padStart(2, '0');
    return `${day}-${month}-${year} ${hours}:${minutes}:${seconds}`;
};

  return (
    <>
      <MainLayout>
        <div>
          <h2 className='text-lg mt-12 mx-8 border-b border-b-gray-300 text-white'>Dictation Set List</h2>
        </div>
        <div className="my-2 mx-auto max-w-[700px] py-4">
            <div className="border border-gray-300 p-4 mt-4">
              <div className="mt-2">
                <div className="mt-2">
                  {bookMasters && bookMasters.length !== 0 && (
                    <div className="flex justify-between items-center border-b border-b-gray-300">
                      <div>
                      <h3 className='text-m mt-1 mx-1 text-yellow-200'>{bookMasters.length} Books Found!</h3>
                      </div>
                      <div className='mr-4'>
                      <Link to='/authordesk-bookmaster/add' className='block w-full h-full px-1 py-2 ml-4 bg-blue-500'>
                        <FontAwesomeIcon className="bg-blue-500 mr-4" icon={faPlus} />  Add New
                      </Link>
                    </div>
                  </div>
                  )}
                </div>
              </div>
              {loading ? (
                <Loader />
              ) : (
                <div>
                  {bookMasters && bookMasters.length === 0 ? (
                    <div className='w-[600px] h-[300px] flex items-center justify-center gap-4 text-yellow-300'>
                      <div className="flex justify-between items-center">
                      <div>
                      <h3 className='text-lg mt-1 mx-2 text-orange-400'>No Record Found!</h3>
                      </div>
                      <div>
                      <Link to='/authordesk-bookmaster/add' className='block w-full h-full px-1 py-2 ml-4 bg-blue-500'>
                        <FontAwesomeIcon className="bg-blue-500 mr-4" icon={faPlus} />  Add New
                      </Link>
                    </div>
                  </div>
                    </div>
                  ) : (
                    sortedBookMasters.map((bookmaster, index) => (
                      <div key={bookmaster._id} className='bg-white my-1 p-1 text-gray-600 rounded-md shadow-md text-sm'>
                        <div className='flex'>
                          <span className='font-medium'>{index + 1}{'. '}{bookmaster.bookTitle}{', '}({formatDateTime(bookmaster.dateCreated)})</span>
                          <Tooltip text={"View details"} position={"top"}>
                            <span className='ml-auto mr-4 text-blue-500 cursor-pointer' onClick={() => handleView(bookmaster._id)}>
                              <i className="fa-solid fa-eye"></i>
                            </span>
                          </Tooltip>
                          <Tooltip text={"Edit this record"} position={"top"}>
                            <Link to={`/authordesk-bookmaster/${bookmaster._id}`} className='mr-4 text-green-600 cursor-pointer'>
                              <i className="fa-solid fa-pen"></i>
                            </Link>
                          </Tooltip>
                        </div>
                        {selectedBookMasterId === bookmaster._id && (
                          <div className='bg-gray-200 text-black'>
                            <p className='bg-blue-700 text-white justify-center text-m mt-2 mb-2'>
                              <h2 className='text-white'><strong>Details</strong></h2>
                            </p>
                            <p><strong>Title:</strong> {bookmaster.title}</p>
                            <div>
                              <strong>Description:</strong>
                              <div dangerouslySetInnerHTML={{ __html: bookmaster.bookDesc }} />
                            </div>
                          </div>
                        )}
                      </div>
                    ))
                  )}
                </div>
              )}
            </div>
          </div>
      </MainLayout>
    </>
  )
}

export default DictaSetList